export enum ReplacementScheduleType {
  FULL_DAY = 'REPLACEMENT_SCHEDULE_TYPE_FULL_DAY',
  MORNING = 'REPLACEMENT_SCHEDULE_TYPE_MORNING',
  AFTERNOON = 'REPLACEMENT_SCHEDULE_TYPE_AFTERNOON',
}
